import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Stack } from "@phosphor-icons/react";

export function AddFromLibraryDialog({
  libOpen, setLibOpen, phases, libItems, libPhase, setLibPhase, libSel,
  toggleLib, setLibQty, applyLibrary, libApplying, navigate, money, moneyPrecise,
}) {
  return (
    <Dialog open={libOpen} onOpenChange={setLibOpen}>
      <DialogContent className="rounded-none max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><Stack size={20} /> Add from Cost Library</DialogTitle></DialogHeader>
        <div className="space-y-4" data-testid="library-dialog">
          <div>
            <Label className="label-caps">Target Phase</Label>
            <Select value={libPhase} onValueChange={setLibPhase}>
              <SelectTrigger className="mt-2 rounded-none" data-testid="library-phase-select"><SelectValue placeholder="Select phase" /></SelectTrigger>
              <SelectContent>
                {phases.map((ph) => <SelectItem key={ph.id} value={ph.id}>{ph.name}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          {libItems.length === 0 ? (
            <div className="border border-dashed border-border p-8 text-center text-sm text-muted-foreground">
              Your cost library is empty. Add reusable trade costs in <button onClick={() => navigate("/cost-library")} className="text-primary underline underline-offset-4">Cost Library</button>.
            </div>
          ) : (
            <div className="border border-border divide-y divide-border max-h-[45vh] overflow-y-auto">
              {libItems.map((it) => {
                const checked = libSel[it.id] != null;
                const qty = libSel[it.id] || 1;
                return (
                  <div key={it.id} data-testid={`library-item-${it.id}`} className="flex items-center gap-3 p-3">
                    <input type="checkbox" checked={checked} onChange={() => toggleLib(it.id)} className="h-4 w-4 accent-black shrink-0" data-testid={`library-check-${it.id}`} />
                    <div className="flex-1 min-w-0">
                      <div className="font-medium text-sm truncate">{it.description}</div>
                      <div className="text-xs text-muted-foreground">{it.category}{it.unit ? ` · ${it.unit}` : ""} · <span className="font-mono-fig">{moneyPrecise(it.default_budget)}</span></div>
                    </div>
                    {checked && (
                      <div className="flex items-center gap-2 shrink-0">
                        <span className="text-xs text-muted-foreground">Qty</span>
                        <Input type="number" step="0.01" min="0" value={qty} onChange={(e) => setLibQty(it.id, e.target.value)}
                          className="w-20 h-8 rounded-none font-mono-fig" data-testid={`library-qty-${it.id}`} />
                        <span className="font-mono-fig text-sm tabular-nums w-24 text-right">{money((it.default_budget || 0) * (Number(qty) || 0))}</span>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
          <DialogFooter>
            <Button onClick={applyLibrary} disabled={libApplying || !Object.keys(libSel).length} data-testid="library-apply-button" className="rounded-none">
              <Plus size={16} className="mr-1" />
              {libApplying ? "Adding…" : `Add ${Object.keys(libSel).length || ""} to Phase`}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
